/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_DoneInputs */

const cs_auth_reset_done = /** @type {(inputs: Auth_Reset_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo bylo změněno. Přihlaste se novým heslem.`)
};

const en_auth_reset_done = /** @type {(inputs: Auth_Reset_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password updated. Sign in with your new password.`)
};

/**
* | output |
* | --- |
* | "Password updated. Sign in with your new password." |
*
* @param {Auth_Reset_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_done = /** @type {((inputs?: Auth_Reset_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_done(inputs)
	return cs_auth_reset_done(inputs)
});